import {Fragment} from "react";

//Material UI
import FormDialog from "./FormDialog";

const NuevaBatea = () => {
    return (
        <Fragment>
            <FormDialog />
        </Fragment>
    );
};

export default NuevaBatea;

